import { render, staticRenderFns } from "./purchase-statistics.vue?vue&type=template&id=5581ad02&scoped=true"
import script from "./purchase-statistics.vue?vue&type=script&lang=js"
export * from "./purchase-statistics.vue?vue&type=script&lang=js"
import style0 from "./purchase-statistics.vue?vue&type=style&index=0&id=5581ad02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5581ad02",
  null
  
)

export default component.exports